import { useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { useQuiz } from "api/questionnaire";
import PersonalAINotFound from "sections/PersonalAI/PersonalAINotFound";
import Loader from "components/Loader";
import PrimaryButton from "components/common/Button/PrimaryButton";
import AcademicCap from "assets/icons/AcademicCap";
import Popularity from "assets/icons/PopularityIcon";
import Clock from "assets/icons/Clock";
import OutlinedButton from "components/common/Button/OutlinedButton";
import HollandCodeAttempt from "./HollandCodeAttempt";
import { useState } from "react";
import HeaderSection from "components/HeaderSection";
import { useTranslation } from "react-i18next";

export default function HollandCode() {
  const { id } = useParams();
  const { dir, language } = useAppSelector(getSettings);
  const { data, isLoading } = useQuiz(id);
  const [startQuiz, setStartQuiz] = useState(false);
  const { t } = useTranslation();

  if (startQuiz)
    return <HollandCodeAttempt onFinish={() => setStartQuiz(false)} />;

  if (isLoading) return <Loader type="block" open />;
  if (!data) return <PersonalAINotFound />;
  return (
    <div dir={dir} className="bg-white">
      <HeaderSection bgImage={data?.questionnaire?.cover_image} />
      <div className="container flex flex-col md:flex-row justify-between gap-10 flex-1 mt-5 md:mt-28 px-10 pb-10 md:pb-28">
        <div className="flex flex-col gap-3 w-full md:w-2/3">
          <div className="flex md:flex-row gap-3 justify-between items-center flex-col">
            <div className="flex flex-col items-center md:items-start gap-3">
              <h1 className="text-theme-blue text-2xl font-semibold">
                {data?.questionnaire?.title[language]}
              </h1>
              <div className="flex items-center gap-3 justify-between w-full md:justify-normal">
                <div className="flex items-center gap-3">
                  <Clock />
                  <span>
                    {data?.questionnaire?.duration} {t("quizTimeMinutes")}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <AcademicCap />
                  <span>{t(data?.questionnaire?.difficulty)}</span>
                </div>
                <div className="flex items-center gap-3">
                  <Popularity />
                  <span>{data?.questionnaire?.popularity}%</span>
                </div>
              </div>
            </div>
            <div className="mt-6 md:mt-0">
              {data?.progress_precentage !== 100 ? (
                <PrimaryButton
                  className="!bg-theme-yellow px-10 py-2 rounded-lg"
                  onClick={() => setStartQuiz(true)}
                >
                  {t("quizStart")}
                </PrimaryButton>
              ) : (
                <OutlinedButton
                  className="border-theme-yellow px-10 py-2 rounded-lg text-theme-yellow bg-[#FFF7ED]"
                  disabled
                >
                  {t("quizComplete")}
                </OutlinedButton>
              )}
            </div>
          </div>
          {data?.progress_precentage !== 100 ? (
            <pre className="font-heebo whitespace-break-spaces text-justify md:text-start my-5">
              {data.questionnaire?.description[language]}
            </pre>
          ) : (
            <div className="my-5">
              <p className="text-justify md:text-start">
                {t("hollandBasedOnResultsTitle")}
              </p>
              <div className="my-5">
                {data.result.map((res, index) => {
                  if (index > 2) return null;
                  return (
                    <div className="mt-3" key={index}>
                      <h2 className="font-semibold">
                        {/* {res.group[0]} -  */}
                        {t(`holland${res.group}`)}
                      </h2>
                      <ul>
                        {res.explanation[language]
                          .split(".")
                          .filter((item) => item)
                          .map((item, index) => (
                            <li
                              key={"point-explain" + index}
                              className="list-disc ltr:ml-6 rtl:mr-6 text-justify md:text-start"
                            >
                              {item}.
                            </li>
                          ))}
                      </ul>
                    </div>
                  );
                })}
              </div>
              <p className="text-justify md:text-start">
                {t("hollandFinalParagraph")}
              </p>
            </div>
          )}
        </div>
        <img
          src={
            data?.questionnaire?.description_image
          }
          className="md:h-96 self-center object-contain"
        />
      </div>
    </div>
  );
}
